module.exports = __webpack_public_path__ + "static/media/tire-pressure-warning.2616badb.svg";